import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../helper/apiCall';
import ENDPOINTS from '../../constants/endpoints';

// Async thunks
export const fetchPlaces = createAsyncThunk(
  'place/fetchPlaces',
  async (branchId, { rejectWithValue, getState }) => {
    try {
      const url = branchId
        ? `${ENDPOINTS.PLACES.GET_LIST}?branchId=${branchId}`
        : ENDPOINTS.PLACES.GET_LIST;
      const response = await client.get(url, {
        token: getState().auth.token
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Bir hata oluştu');
    }
  }
);

export const createPlace = createAsyncThunk(
  'place/createPlace',
  async (placeData, { rejectWithValue, getState  }) => {
    try {
      const response = await client.post(ENDPOINTS.PLACES.CREATE, placeData, {
        token: getState().auth.token
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Bir hata oluştu');
    }
  }
);

export const updatePlace = createAsyncThunk(
  'place/updatePlace',
  async ({ id, placeData }, { rejectWithValue, getState }) => {
    try {
      const response = await client.put(ENDPOINTS.PLACES.UPDATE.replace(':id', id), placeData, {
        token: getState().auth.token
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Bir hata oluştu');
    }
  }
);

export const deletePlace = createAsyncThunk(
  'place/deletePlace',
  async (id, { rejectWithValue, getState }) => {
    try {
      await client.delete(ENDPOINTS.PLACES.DELETE.replace(':id', id),{}, {
        token: getState().auth.token
      });
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Bir hata oluştu');
    }
  }
);

const placeSlice = createSlice({
  name: 'place',
  initialState: {
    places: [],
    status: 'idle',
    error: null,
    loading: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearStatus: (state) => {
      state.status = 'idle';
    },
  },
  extraReducers: (builder) => {
    // Fetch places
    builder
      .addCase(fetchPlaces.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlaces.fulfilled, (state, action) => {
        state.loading = false;
        state.places = action.payload.items || [];
        state.status = 'succeeded';
      })
      .addCase(fetchPlaces.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.status = 'failed';
      })
      // Create place
      .addCase(createPlace.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPlace.fulfilled, (state, action) => {
        state.loading = false;
        state.places.push(action.payload);
        state.status = 'succeeded';
      })
      .addCase(createPlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.status = 'failed';
      })
      // Update place
      .addCase(updatePlace.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePlace.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.places.findIndex(place => place.id === action.payload.id);
        if (index !== -1) {
          state.places[index] = action.payload;
        }
        state.status = 'succeeded';
      })
      .addCase(updatePlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.status = 'failed';
      })
      // Delete place
      .addCase(deletePlace.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePlace.fulfilled, (state, action) => {
        state.loading = false;
        state.places = state.places.filter(place => place.id !== action.payload);
        state.status = 'succeeded';
      })
      .addCase(deletePlace.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.status = 'failed';
      });
  }
});

export const { clearError, clearStatus } = placeSlice.actions;
export default placeSlice.reducer; 